<template>
  <div class="sidebar">
    <el-menu
      class="sidebar-el-menu"
      :default-active="onRoutes"
      :collapse="collapse"
      background-color="#545c64"
      text-color="#fff"
      active-text-color="#ffd04b"
      unique-opened
      router
    >
      <template v-for="item in items">
        <template v-if="item.subs">
          <el-submenu
            :index="item.index"
            :key="item.index"
            v-if="item.stautes == true"
          >
            <template slot="title">
              <i :class="item.icon"></i>
              <span slot="title">{{ item.title }}</span>
            </template>
            <template v-for="subItem in item.subs">
              <el-submenu
                v-if="subItem.subs"
                :index="subItem.index"
                :key="subItem.index"
              >
                <template slot="title">{{ subItem.title }}</template>
                <el-menu-item
                  v-for="(threeItem, i) in subItem.subs"
                  :key="i"
                  :index="threeItem.index"
                  >{{ threeItem.title }}</el-menu-item
                >
              </el-submenu>
              <el-menu-item
                v-else
                :index="subItem.index"
                :key="subItem.index"
                >{{ subItem.title }}</el-menu-item
              >
            </template>
          </el-submenu>
        </template>
        <template v-else>
          <el-menu-item
            :index="item.index"
            :key="item.index"
            v-if="item.stautes == true"
          >
            <i :class="item.icon"></i>
            <span slot="title">{{ item.title }}</span>
          </el-menu-item>
        </template>
      </template>
    </el-menu>
  </div>
</template>

<script>
import axios from "axios";
import { getuserInfo } from "@/lib/until";
export default {
  props: ["roles"],
  data() {
    return {
      collapse: false,
      items: [
        {
          stautes: true,
          id: 1,
          icon: "el-icon-lx-qrcode",
          index: "Preson",
          title: "个人日工作",
        },
        {
          stautes: true,
          id: 2,
          icon: "el-icon-lx-addressbook",
          index: "PersonOvertime",
          title: "个人加班",
        },
        {
          stautes: false,
          id: 3,
          icon: "el-icon-lx-friend",
          index: "3",
          title: "部门管理",
          subs: [
            {
              index: "departwork",
              title: "部门日工作",
            },
            {
              index: "departovertime",
              title: "部门加班",
            },
          ],
        },
        {
          stautes: false,
          id: 4,
          icon: "el-icon-lx-attention",
          index: "1",
          title: "审批功能",
          subs: [
            {
              index: "Examine",
              title: "加班审批",
            },
            {
              index: "rest",
              title: "调休审批",
            },
          ],
        },

        {
          stautes: true,
          id: 5,
          icon: "el-icon-lx-lock",
          index: "AChangepasswrod",
          title: "修改密码",
        },
        {
          stautes: true,
          id: 6,
          icon: "el-icon-lx-edit",
          index: "Explain",
          title: "使用说明",
        },
        {
          stautes: true,
          id: 7,
          icon: "el-icon-lx-time",
          index: "gr",
          title: "加班详情",
        },
        {
          stautes: true,
          id: 8,
          icon: "el-icon-lx-comment",
          index: "porjectProgress",
          title: "项目进度",
        },
        {
          stautes: true,
          id: 9,
          icon: "el-icon-lx-remind",
          index: "workplan",
          title: "工作安排",
        },
        {
          stautes: false,
          id: 10,
          icon: "el-icon-lx-sort",
          index: "tuozhuai",
          title: "项目拖拽排序",
        },
        // {
        //   stautes: true,
        //   id: 11,
        //   icon: "el-icon-lx-sort",
        //   index: "zhongkong",
        //   title: "中控测试"
        // },
        {
          stautes: false,
          id: 11,
          icon: "el-icon-lx-skin",
          index: "allKpi",
          title: "总Kpi",
        },
        {
          stautes: false,
          id: 12,
          icon: "el-icon-lx-sort",
          index: "zgs",
          title: "项目总工时",
        },
        {
          stautes: true,
          id: 13,
          icon: "el-icon-lx-news",
          index: "rwperson",
          title: "个人任务",
        },
        {
          stautes: false,
          id: 14,
          icon: "el-icon-lx-exit",
          index: "xmbg",
          title: "项目任务分配",
        },
        {
          stautes: false,
          id: 15,
          icon: "el-icon-lx-global",
          index: "qx",
          title: "分配项目授权",
        },
        {
          stautes: true,
          id: 16,
          icon: "el-icon-lx-edit",
          index: "Xinrenwu",
          title: "周项目分配",
        },
        {
          stautes: true,
          id: 17,
          icon: "el-icon-lx-edit",
          index: "kanrenwu",
          title: "查看周项目分配",
        },
      ],
    };
  },
  computed: {
    onRoutes() {
      return this.$route.path.replace("/", "");
    },
  },
  created() {
    //重组items
    this.Citems();
    // 通过 Event Bus 进行组件间通信，来折叠侧边栏
    bus.$on("collapse", (msg) => {
      this.collapse = msg;
      bus.$emit("collapse-content", msg);
    });
  },
  methods: {
    Citems() {
      //console.log(this.roles);
      for (let key in this.roles) {
        if (this.roles[key] == 3) {
          for (let key2 in this.items) {
            if (this.items[key2].id == 3) {
              this.items[key2].stautes = true;
            }
          }
        }
        if (this.roles[key] == 1) {
          for (let key2 in this.items) {
            if (this.items[key2].id == 4) {
              this.items[key2].stautes = true;
            }
          }
        }
        if (this.roles[key] == 5) {
          for (let key2 in this.items) {
            if (this.items[key2].id == 10 || this.items[key2].id == 11) {
              this.items[key2].stautes = true;
            }
          }
        }
        if (this.roles[key] == 6) {
          for (let key2 in this.items) {
            if (this.items[key2].id == 12) {
              this.items[key2].stautes = true;
            }
          }
        }
        if (this.roles[key] == 7) {
          for (let key2 in this.items) {
            if (this.items[key2].id == 15) {
              this.items[key2].stautes = true;
            }
            if (this.items[key2].id == 14) {
              this.items[key2].stautes = true;
            }
          }
        }
      }
      //console.log(this.items);
      axios
        .post(IPConfig.IP + "/kpi-management/qxgl/xmliebiao.php")
        .then((res) => {
          console.log(res.data.qx_result);
          let qxperson = res.data.qx_result;
          let uesrInfo = JSON.parse(localStorage.getItem("uesrInfo"));
          for (let key in qxperson) {
            if (qxperson[key].employee_id == uesrInfo.employee_id) {
              console.log(qxperson[key]);
              for (let key2 in this.items) {
                if (this.items[key2].id == 14) {
                  this.items[key2].stautes = true;
                }
              }
            }
          }
        });
      this.getPorjectList().then((res) => {
        console.log(res);
        if (res > 0) {
          this.items.forEach((element) => {
            if (element.id == 16) {
              element.stautes = true;
            }
          });
        } else {
          this.items.forEach((element) => {
            if (element.id == 16) {
              element.stautes = false;
            }
          });
        }
      });
    },
    //获取项目列表数据
    getPorjectList() {
      let getInfo = getuserInfo();
      //做一些异步操作
      var p = new Promise(function (resolve, reject) {
        axios
          .post(
            IPConfig.IP + "/kpi-management/mgmt/project/sel_project_list.php",
            {
              employee_id: getInfo.employee_id,
              //employee_id: 126,
            }
          )
          .then((res) => {
            console.log(res.data.project_results);
            let projectList = res.data.project_results;
            let projectLength = projectList.length;
            resolve(projectLength);
            // return projectLength;
          });

        // setTimeout(function(){
        //     console.log('执行完成');
        //     resolve('随便什么数据');
        // }, 2000);
      });
      return p;
    },
  },
};
</script>

<style scoped>
.sidebar {
  display: block;
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  overflow-y: scroll;
}
.sidebar::-webkit-scrollbar {
  width: 0;
}
.sidebar-el-menu:not(.el-menu--collapse) {
  width: 181px;
}
.sidebar > ul {
  height: 100%;
}
.el-menu {
  border-right: 1px solid #444 !important;
}
.el-submenu .el-menu-item {
  min-width: 180px !important;
  padding-left: 50px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/common/Sidebar.vue